// Insights/constants.js

// This will be used later in our root reducer and selectors
export const NAME = 'admins';
export const LEVEL_ONE = 'AdminsComponentReducer';
